import styled from 'styled-components'

export const ProductCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(8)};
  width: 100%;

  ${({ theme }) => theme.mediaQuery.md} {
    width: 80%;
  }
`
